import { render } from "./hris-before-ask-for-dates.vue?vue&type=template&id=644a5ff3&lang=pug"
import script from "./hris-before-ask-for-dates.vue?vue&type=script&lang=js"
export * from "./hris-before-ask-for-dates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__